module.exports = __webpack_public_path__ + "b709ffab320a287be6fcbbb02423f60d.fbx";